module.exports = __webpack_public_path__ + "d854b03c02cec1f16accf9c3e0a41c35.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_icon.png
// module id = 27
// module chunks = 0 1 2 3 4